import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert } from '@mui/material';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import {
  TotpMultiFactorGenerator,
  MultiFactorResolver,
} from 'firebase/auth';

export const MfaVerifyPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const resolver = (location.state as { resolver?: MultiFactorResolver })?.resolver;
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (!resolver) return <Navigate to="/login" replace />;

  const handleVerify = async () => {
    setLoading(true);
    setError(null);
    try {
      const hint = resolver.hints.find((h) => h.factorId === TotpMultiFactorGenerator.FACTOR_ID);
      if (!hint) throw new Error('Nessun TOTP enrollato');
      const assertion = TotpMultiFactorGenerator.assertionForSignIn(hint.uid, code);
      await resolver.resolveSignIn(assertion);
      navigate('/tenants', { replace: true });
    } catch (e) {
      console.error('MFA verify failed', e);
      setError('Codice errato. Riprova.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Paper sx={{ p: 4, maxWidth: 400 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Verifica MFA</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Inserisci il codice a 6 cifre generato dalla tua app authenticator.
        </Typography>
        <TextField
          label="Codice TOTP"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          fullWidth
          margin="normal"
          slotProps={{ htmlInput: { maxLength: 6, inputMode: 'numeric' } }}
        />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading || code.length !== 6}
          onClick={handleVerify}
        >
          {loading ? 'Verifica...' : 'Conferma'}
        </Button>
      </Paper>
    </Box>
  );
};
